import { TableCell } from '@tiptap/extension-table/cell';
import { TableHeader } from '@tiptap/extension-table/header';

function parseBackgroundColor(element) {
  const bgcolor = element.getAttribute('bgcolor')?.trim();
  if (bgcolor) return bgcolor;
  const inline = element.style.backgroundColor?.trim();
  if (inline && inline !== 'transparent' && inline !== 'rgba(0, 0, 0, 0)') return inline;
  return null;
}

function renderBackgroundHtml(attributes) {
  if (!attributes.backgroundColor) return {};
  const v = String(attributes.backgroundColor).trim();
  if (!v) return {};
  /* bgcolor keeps align's CSS `style` untouched; hex presets use bgcolor */
  if (v.startsWith('#')) {
    return { bgcolor: v };
  }
  return { style: `background-color: ${v}` };
}

export const TableCellWithBg = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: (element) => parseBackgroundColor(element),
        renderHTML: (attributes) => renderBackgroundHtml(attributes),
      },
    };
  },
});

export const TableHeaderWithBg = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: (element) => parseBackgroundColor(element),
        renderHTML: (attributes) => renderBackgroundHtml(attributes),
      },
    };
  },
});
